import { gql } from "@apollo/client"
import { type GetDEXStatsResponseType } from "@tutellus/dappcomposer-contracts-ifaces"

export const GET_PROJECT_STATS_QUERY = gql`
  query GET_PROJECT_STATS_QUERY {
    getDEXStats {
      __typename
      ... on ProjectDEXStats {
        tvl {
          number
          currencyID
        }
        volume {
          number
          currencyID
        }
        tx
        bribes {
          number
          currencyID
        }
        fees {
          number
          currencyID
        }
        income {
          number
          currencyID
        }
      }
      ... on SimpleError {
        description
      }
    }
  }
`

export type GetProjectStatsQueryResponse = {
  getDEXStats: GetDEXStatsResponseType
}
